import { render, staticRenderFns } from "./TarimaTableComponent.vue?vue&type=template&id=eb769c04&"
import script from "./TarimaTableComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports